import { ColumnDef } from '@tanstack/react-table'
import { EnergySourceAndContract } from '@/hooks/useApi/types'
import { EnergySourcingContractsTableLabelsMap } from './useEnergySourcingContractsTableLabelsMap'
import { TruncatableText } from '@/components/molecules/TruncatableText/TruncatableText'
import { formatTimeSinceUpdate } from '@/utils/formatTimeSinceUpdate'
import dayjs from 'dayjs'

export const getColumns = (
    labelsMap: EnergySourcingContractsTableLabelsMap,
    currentUserContactId: number | null = null
): ColumnDef<EnergySourceAndContract>[] => {
    const columns: ColumnDef<EnergySourceAndContract>[] = [
        {
            id: 'name',
            accessorKey: 'name',
            header: labelsMap['name'],
            cell: ({ cell }) => {
                const cellValue = cell.getValue()

                if (typeof cellValue === 'string') {
                    return (
                        <TruncatableText
                            text={cellValue}
                            tooltipClassname="max-w-tooltipWidth break-words"
                        />
                    )
                }
            },
        },
        {
            id: 'type',
            accessorKey: 'type',
            header: labelsMap['type'],
            cell: ({ cell }) => {
                const cellValue = cell.getValue()
                return cellValue as string
            },
        },
        {
            id: 'usnCount',
            accessorKey: 'usnCount',
            header: labelsMap['usnCount'],
            cell: ({ cell }) => {
                const cellValue = cell.getValue()
                return cellValue as number
            },
        },
        {
            id: 'startDate',
            accessorKey: 'startDate',
            header: labelsMap['startDate'],
            sortingFn: 'datetime',
            cell: ({ cell }) => {
                const cellValue = cell.getValue()
                if (typeof cellValue === 'string') {
                    return dayjs(cellValue).format('MM/DD/YYYY')
                }
                return ''
            },
        },
        {
            id: 'endDate',
            accessorKey: 'endDate',
            header: labelsMap['endDate'],
            sortingFn: 'datetime',
            cell: ({ cell }) => {
                const cellValue = cell.getValue()
                if (typeof cellValue === 'string') {
                    return dayjs(cellValue).format('MM/DD/YYYY')
                }
                return ''
            },
        },
        {
            id: 'lastUpdate',
            accessorKey: 'lastUpdate',
            header: labelsMap['lastUpdate'],
            sortingFn: 'datetime',
            cell: ({ cell }) => {
                const cellValue = cell.getValue()
                if (typeof cellValue !== 'string') {
                    return ''
                }
                return formatTimeSinceUpdate(cellValue)
            },
        },
        {
            id: 'updatedBy',
            accessorKey: 'updatedBy',
            header: labelsMap['updatedBy'],
            cell: ({ row }) => {
                if (
                    currentUserContactId &&
                    row.original.contactId === currentUserContactId
                ) {
                    return 'Me'
                }

                return row.original.updatedBy
            },
        },
    ]

    return columns
}
